import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined } from '@ant-design/icons';

import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  List,
  Spin
} from "antd";

//OTHER IMPORTS
import dayjs from 'dayjs';
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';


const { Text } = Typography

const UnassignLoanOfficer = (props) => {

  const { userData, pageTitleParam } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [loanOfficerOptions, setLoanOfficerOptions] = useState([]);
  const [loanOfficerTemplate, setLoanOfficerTemplate] = useState([]);

  const dateFormat = 'YYYY/MM/DD';


  useEffect(() => {
    defaultDate()
  }, []);

  const defaultDate = () => {
    form.setFieldsValue({
      assignmentDate: dayjs(),
    })
  }

  function onCancel() {
    navigate("/detail-child-glim", { state: state });
  }

  const onSubmit = (formValues) => {

    delete formValues.approvedAmt

    formValues.unassignedDate = BOM.DateTime(formValues.unassignedDate, "only-date")

    const params = {
      command: "unassignloanofficer"
    }
    const url = `${apiConfig.Loans}/${state.loanId}`

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
      params
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.unassignLoanOfficerMsg);
        navigate("/detail-child-glim", { state: { ...state, id: state.loanId } });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (

    <MainLayout isEnableRightSidebar={true} >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={pageTitleParam ? pageTitleParam : labelConfig.unassignLoanOfficer}
        pageItems={staticConfig.unassignLoanOfficerBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row >
              <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.unassignedOn}
                  name={"unassignedDate"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        labelConfig.unassignedOn
                      ),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.unassignedOn}`,
                      "select"
                    )}
                    style={{ width: '100%' }}
                    format={dateFormat}
                  />

                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("REMOVELOANOFFICER_LOAN") &&
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>

        </Card>
      </Spin>

    </MainLayout>

  )
}

export default UnassignLoanOfficer